import React, { useEffect, useState, useRef } from "react";
import { Col, Card, Table, Alert, Spinner } from "react-bootstrap";
import { Link,useHistory} from "react-router-dom";
import Baseurl from "../../../Baseurl";
import axios from "axios";
import swal from "sweetalert";
function Transaction() {
  const history=useHistory()
  const [data, setData] = useState([]);
  const sort = 25;
  const activePag = useRef(0);
  const [transaction, setTransaction] = useState([]);
  const [searchData, setSearchData] = useState([]);
  const [spinner, setSpinner] = useState(true);
  function getData(length) {
    axios.get(Baseurl.baseurl + `/go-transaction/get-transaction/${length}`).then((res) => {
      setSpinner(false);
      if(res.data.status){
        // setTransaction(res.data.transaction.reverse());
        // setSearchData(res.data.transaction);
        setTransaction(
          (oldArray) => oldArray.concat(res.data.transaction.reverse()),
          () => {}
        );
        setSearchData(
          (oldArray) => oldArray.concat(res.data.transaction.reverse()),
          () => {}
        );
        setData(document.querySelectorAll("#job_data tbody tr"))
      }
      else{
        swal("No More Data", "", "error", {
          button: "Done",
          timer: 1000,
        });

      }
     
    })
    .catch((err) => {
      if(err.toString()==="Error: Network Error")
      {
        history.push('/offline')
      }
      else
      {
        history.push('/400')
      }
  })
  }
  const chageData = (frist, sec) => {
    for (var i = 0; i < data.length; ++i) {
      if (i >= frist && i < sec) {
        data[i].classList.remove("d-none");
      } else {
        data[i].classList.add("d-none");
      }
    }
  };
  activePag.current === 0 && chageData(0, sort);
  let paggination = Array(Math.ceil(data.length / sort))
    .fill()
    .map((_, i) => i + 1);
  const onClick = (i) => {
    activePag.current = i;
    chageData(activePag.current * sort, (activePag.current + 1) * sort);
  };

  useEffect(() => {
    getData(transaction.length);
  }, []);

  function searchRider(value) {
    // let filteredData = [];
    
    // if(searchData){
    //   searchData.map((val) => {
    //     let phoneString = val.PhoneNumber.toString();
    //     if (
    //       val.TransactionId.toLowerCase().includes(value) ||
    //       val.Type.toLowerCase().includes(value) ||
    //       val.Purpose.toLowerCase().includes(value)||
    //       val.Date.toLowerCase().includes(value)||
    //       val.By.toLowerCase().includes(value)||phoneString.includes(value)
    //     ) {
    //       filteredData.push(val);
          
    //     }
    //   });
    //   setTransaction(filteredData);
    // }
    if(value.length===24){
      axios.get(
        `${
          Baseurl.baseurl
        }/go-transaction/get-transaction-by-id/${value}`
      )
      .then((res) => {
        // let orderArray=[]
        // orderArray.push(res.data.transaction)
        setTransaction(res.data.transaction);
        setData(document.querySelectorAll("#job_data tbody tr"))
      })
      .catch((err) => {
        if(err.toString()==="Error: Network Error")
        {
          history.push('/offline')
        }
        else
        {
          history.push('/400')
        }
    })
    }
   
  }
  return (
    <Col lg={12}>
      <Card  style={{
          color: "white",
          background:
            "linear-gradient(90deg, #135334 0%, #98e7c1 100%)",
        }}> 
        <Card.Header>
          <Card.Title className="text-white">All Transactions</Card.Title>
          <div>
            <input
              type="text"
              className="form-control"
              placeholder="Search here..."
              onChange={(e) => {
                searchRider(e.target.value);
              }}
            />
          </div>
        </Card.Header>
        <Card.Body>
          <div id="job_data" className="dataTables_wrapper ">
            {spinner ? (
              <div className="text-center">
                <Spinner animation="border" variant="primary" />
              </div>
            ) : (
              <Table responsive className="table text-white">
                <thead>
                  <tr>
                    {/* <th>
                      <strong>SL NO.</strong>
                    </th> */}
                    <th>
                      <strong>Trans Id</strong>
                    </th>
                    <th>
                      <strong>Status</strong>
                    </th>
                    <th>
                      <strong>Phone</strong>
                    </th>
                    <th>
                      <strong>Amount</strong>
                    </th>
                    <th>
                      <strong>From</strong>
                    </th>
                    <th>
                      <strong>Type</strong>
                    </th>
                    <th>
                      <strong>Purpose</strong>
                    </th>
                    <th>
                      <strong>Date-Time</strong>
                    </th> 
                  </tr>
                </thead>
                <tbody>
                  {transaction &&
                    transaction.map((trans, key) => (
                      <tr key={trans._id}>
                        <td>
                          {trans.Id} 
                        </td>
                        <td>
                          {trans.Status} 
                        </td>
                        <td>{trans.PhoneNumber}</td>
                        <td>{trans.Amount}</td>
                        <td>{trans.By}</td>
                        <td>{trans.Type}</td>
                        <td>{trans.Purpose}</td>
                        <td>{trans.Date}-{trans.Time}</td>
                      </tr>
                    ))}
                </tbody>
              </Table>
            )}
            {!transaction && (
              <Alert
                variant="success"
                className="alert-dismissible fade show text-center"
              >
                Zero riders
              </Alert>
            )}
            <div className="d-sm-flex text-center justify-content-between align-items-center mt-3">
              <div className="dataTables_info text-white">
                Showing {activePag.current * sort + 1} to{" "}
                {data.length > (activePag.current + 1) * sort
                  ? (activePag.current + 1) * sort
                  : data.length}{" "}
                of {data.length} entries
              </div>
              <div
                className="dataTables_paginate paging_simple_numbers"
                id="example5_paginate"
              >
                <Link
                  className="paginate_button previous disabled"
                  onClick={() =>
                    activePag.current > 0 && onClick(activePag.current - 1)
                  }
                >
                  Previous
                </Link>
                <span>
                  {paggination.map((number, i) => (
                    <Link
                      key={i}
                      className={`paginate_button  ${
                        activePag.current === i ? "current" : ""
                      } `}
                      onClick={() => onClick(i)}
                    >
                      {number}
                    </Link>
                  ))}
                </span>
                <Link
                  className="paginate_button next"
                  onClick={() => {
                    activePag.current + 1 < paggination.length &&
                      onClick(activePag.current + 1);
                  }}
                >
                  Next
                </Link>
                <button onClick={()=>{
               
               getData(transaction.length)
               }} className="btn btn-primary ml-2">Next</button>
              </div>
            </div>
          </div>
        </Card.Body>
      </Card>
    </Col>
  );
}

export default Transaction;
